import type { I$W } from '@wix/yoshi-flow-editor';

import type { MultiStateBoxService as IMultiStateBoxService } from '../types';

enum AppState {
  Main = 'main',
  Error = 'error',
}

type W = I$W<{
  '#appStates': $w.MultiStateBox;
  '#appsContainer': $w.MultiStateBox;
}>;

export class MultiStateBoxService implements IMultiStateBoxService {
  constructor(private readonly $w: W) {}

  async showMainAppState() {
    await this.getAppStatesMSB()?.changeState?.(AppState.Main);
  }

  async showErrorAppState() {
    await this.getAppStatesMSB()?.changeState?.(AppState.Error);
  }

  async showSlotStateById(stateId: string) {
    await this.getSlotsStatesMSB()?.changeState?.(stateId);
  }

  getCurrentStateId() {
    const msb = this.getSlotsStatesMSB();

    return msb?.currentState?.id ?? '';
  }

  private getAppStatesMSB(): $w.MultiStateBox | null {
    return this.$w('#appStates');
  }

  private getSlotsStatesMSB(): $w.MultiStateBox | null {
    return this.$w('#appsContainer');
  }
}
